import * as React from 'react';
import { BwjTableComponent, IBwjTableProps } from './component';

interface IState {}

export class BwjTable<T> extends React.Component<IBwjTableProps<T>, IState> {

  public render() {
    return (<BwjTableComponent {...this.props} />);
  }
}